import { quantitiesPayload } from '@/helpers/TicketTypeQuantities'

import { API } from '@/api/API'
import { dateTimeHorizon } from '@/api/dateTimeHorizon'
import { EventDetails } from '@/api/types/processedEntities'

export type CalendarApiResponse = EventBasicDateData[] | EventDateData[]

export async function fetchCalendarForTicketGroupIDs(
  event: EventDetails,
  ticketGroupIds: string[],
): Promise<EventBasicDateData[]> {
  const query = {
    _format: 'extended',
    'ticket_group_id._in': ticketGroupIds.join(','),
    'start_datetime._lt': dateTimeHorizon(event),
  }

  const response = await API.getCached<'calendar'>(`events/${event.id}/calendar`, { query })
  return response.calendar._data
}

export async function fetchCalendarForTicketTypes(
  event: EventDetails,
  quantities: TicketTypeQuantities,
  includePricing: boolean,
): Promise<CalendarApiResponse> {
  const query = {
    _format: includePricing ? 'price' : 'extended',
    'start_datetime._lt': dateTimeHorizon(event),
  }

  const body = quantitiesPayload(quantities)
  const response = await API.post<'calendar'>(`events/${event.id}/calendar`, { query, body })
  return response.calendar._data
}
